module.exports = __webpack_public_path__ + "static/media/cases_3d_01e.dd9f9cd7.jpg";